/**
 * FP dashboard → Network tab curated panel (Feature 096).
 * Compact "bQuest Preferred Providers" rows below the My Network card:
 * Message opens the messaging thread, Refer opens the existing referral modal.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CuratedProvidersPanel } from '@/shared/components/curated';
import { ReferralModal } from './ReferralModal';

export function CuratedProvidersCard() {
  const navigate = useNavigate();
  const [referralModalOpen, setReferralModalOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<{ id: string; name: string } | null>(
    null,
  );

  return (
    <>
      <CuratedProvidersPanel
        variant="row"
        onMessage={(userId) => navigate(`/messages?recipient=${userId}`)}
        onRefer={(serviceProviderId, providerName) => {
          setSelectedProvider({ id: serviceProviderId, name: providerName });
          setReferralModalOpen(true);
        }}
      />
      <ReferralModal
        open={referralModalOpen}
        onOpenChange={setReferralModalOpen}
        providerId={selectedProvider?.id || null}
        providerName={selectedProvider?.name || ''}
      />
    </>
  );
}
